module.exports = __webpack_public_path__ + "img/miniLogo.af1a7396.png";